angular.module('impactx').service('$workspaceIdHolder', WorkspaceIdHolderService);

function WorkspaceIdHolderService() {
    this.currentWorkspaceId = {};
    this.suffixForTheme = {};
    this.themeWorldTheme = {};
}